import React from 'react';

import { Link, useLocation } from 'react-router-dom';
import { navigateTop } from 'common/utils/index';

import styles from './AppFooter.module.scss';
import { Logo, Mail, TwitterDP, FacebookDP, InstagramDP, LinkedinDP } from 'assets/landing/index';
import textStyles from 'common/styles/text.module.scss';

const Footer = (): React.ReactElement => {
  const location = useLocation();
  const isLanding = location.pathname == '/';

  return (
    <div className={`${!isLanding && styles.footerContainer}`}>
      <div className="row me-1">
        <div className="col-6 d-flex flex-column align-items-start">
          <div style={{ maxWidth: '350px', marginLeft: '80px' }}>
            <Link to="" onClick={() => navigateTop()}>
              <img src={Logo} alt="logo" width="200" />
            </Link>
            <p className={`mt-4 ms-3 ${textStyles['text-secondary-22-400']}`}>
              The smart way to apply to business school.
            </p>
            <div style={{ maxWidth: '250px' }}>
              <div className={`d-flex flex-row mb-4 ${styles.socialMediaContainer}`}>
                <a href="mailto:info@unifyapply.com">
                  <img src={Mail} className={styles.imageSocialContainer} alt="mail" />
                </a>
                <a href="https://twitter.com/unify_apply" target="_blank" rel="noopener noreferrer">
                  <img src={TwitterDP} className={styles.imageSocialContainer} alt="twitter_dp" />
                </a>
                <a
                  href="https://www.facebook.com/unifyapply"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={FacebookDP} className={styles.imageSocialContainer} alt="facebook_dp" />
                </a>
                <a
                  href="https://www.instagram.com/unifyapply/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={InstagramDP}
                    className={styles.imageSocialContainer}
                    alt="instagram_dp"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/unifyapply/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={LinkedinDP} className={styles.imageSocialContainer} alt="linkedin_dp" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-6 ${styles.linksContainer}`}>
          <div className="d-flex justify-content-between">
            <div className="col-4 d-flex flex-column">
              <p className={textStyles['text-primary-20-700']}>Discover</p>
              <Link to="explore/masters" onClick={() => navigateTop()} className={styles.link}>
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>Masters</p>
              </Link>
              {/* <Link to="explore/bachelors" onClick={() => navigateTop()} className={styles.link}>
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>Bachelors</p>
              </Link> */}
            </div>
            <div className="col-4 d-flex flex-column">
              <p className={textStyles['text-primary-20-700']}>About us</p>
              {/* <div>
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>Our stories</p>
              </div> */}
              <a
                href="https://share.hsforms.com/1cp8h0ofzSD6OJODEOos92Aca7fh"
                className={styles.link}
              >
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>
                  Contact us
                </p>
              </a>
              <a
                href="https://blog.unifyapply.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>Blogs</p>
              </a>
            </div>
            <div className="col-4 d-flex flex-column">
              <p className={textStyles['text-primary-20-700']}>Legal</p>
              {/* <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>
                Condition of use
              </p> */}
              <a
                href="https://blog.unifyapply.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                <p className={`${textStyles['text-secondary-18-400']} ${styles.link}`}>
                  Privacy Notice
                </p>
              </a>
            </div>
          </div>
        </div>
        <div className="col-12 d-flex flex-column align-items-center">
          <p
            className={textStyles['text-secondary-16-600']}
            style={{
              textAlign: 'center',
              marginTop: '50px',
            }}
          >
            © 2022 UNIFY. ALL RIGHTS RESERVED
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
